'use client'

import { Cell } from '@vinted/web-ui'

import { useSession } from '@marketplace-web/shared/session-data'

import FollowButton from '@marketplace-web/user-follow/follow-button-feature'

import { ItemPageUserInfoActionsPluginModel } from './types'
import { isDateInTheFuture } from '../../utils/date'

type Props = {
  data: ItemPageUserInfoActionsPluginModel
}

const ItemPageUserInfoActionsPlugin = ({ data }: Props) => {
  const { user: currentUser } = useSession()

  const { sellerId, closetCountdownEndDate, isFavourite } = data

  if (!sellerId) return null
  if (!currentUser || currentUser.id === sellerId) return null
  if (isDateInTheFuture(closetCountdownEndDate)) return null

  return (
    <Cell>
      <FollowButton userId={sellerId} isActive={isFavourite} isFlat />
    </Cell>
  )
}

export default ItemPageUserInfoActionsPlugin
